import $ from "jquery";
import "plugin_wishlists/main";

// custom_cbt - JS files import
import "custom_cbt/pageViewCbt";
import "custom_cbt/cbt";

import { createIcons, icons } from "lucide";

// Components
import initializeExperienceComponents from "./experience/index";
import initComponents from "./components";
import minicart from "./components/miniCart";
import search from "./components/search";
import vehicleSelector from "./components/vehicleSelector";
import searchSuggestions from "./components/searchSuggestions";
import checkoutProgressBar from "./components/checkoutProgressBar";
import toolTip from "base/components/toolTip";
import autoOpenChatFromUrl from "./chatAutoOpen";
import validateForm from "app_ford_ar/components/validateForm";

$(() => {
    // Initial Ford JS Client-side code
    initializeExperienceComponents();
    initComponents();
    minicart();
    search();
    vehicleSelector();
    searchSuggestions();
    createIcons({ icons });
    checkoutProgressBar();
    toolTip();
    autoOpenChatFromUrl();
    validateForm.validateFormInput();
});
